<template>
    <Card class="card .operation_card" style="overflow: hidden">
        <template #header>
            <div class="header-info flex justify-content-around align-items-center p-0">
                <div class="flex align-items-center justify-content-center surface-50 border-round "
                    style="width: 2.5rem; height: 2.5rem">
                    <i :class="['pi', 'pi-info-circle', 'text-blue-500',]" style="cursor: pointer; font-size: 1.25rem"
                        @click="showOperationInfo" />
                </div>

                <div class="flex align-items-center justify-content-center surface-50 border-round"
                    style="width: 2.5rem; height: 2.5rem">
                    <i :class="['pi', 'text-blue-500', getOperationTypeIcon(operation.typeId)]" style="font-size: 1.25rem" />
                </div>
                <div class="flex align-items-center justify-content-center surface-50 border-round"
                    style="width: 2.5rem; height: 2.5rem">
                    <i :class="['pi', 'pi-comments', 'text-blue-500', { 'animation-duration-1000 animation-iteration-infinite fadeout': shouldReadChat }]"
                        style="cursor: pointer; font-size: 1.25rem" @click="showChat" />
                </div>
            </div>
            <Divider class="mb-0 mt-2" />
        </template>

        <template #title>
            <div class="flex justify-content-between align-items-center p-1 mt-2">
                <img :src="operation.sender.imageUrl" class="user_avatar" @click="showUserInfo(operation.sender.id)" />
                <img :src="operation.receiver.imageUrl" class="user_avatar"
                    @click="showUserInfo(operation.receiver.id)" />
            </div>
            <Divider class="mb-0 mt-2" style="border-top: red !important;"/>
        </template>

        <template #content>
            <div style="height: 10em" class="relative">
                <img v-for="i in booksPreview" :key="i" :src="i.src" class="books_preview border-round" :style="i.style"
                    @click="showBooksList" />
            </div>
        </template>

        <template #footer>
            <Divider class="m-0 mb-2" />
            <div>
                <div class="flex justify-content-around align-items-center gap-1 p-1">
                    <span class="border-round surface-50 py-2 flex justify-content-center align-items-center w-full text-sm text-900">
                        {{ $t(operationStatusNumericEnum[operation.statusId]) }}
                    </span>
                    <div v-if="operation.daysToExpire" 
                        v-tip="operation.expiration.toLocaleString()"
                        class="flex-shrink-0 daysToExpire text-sm">
                        {{ operation.daysToExpire }}
                    </div>
                </div>
                <div class="flex justify-content-around align-items-center gap-1 p-1">
                    <div class="border-round surface-50 p-2 flex justify-content-center align-items-center w-full text-sm text-900">
                        {{ operation.timestamp.toLocaleString() }}
                    </div>
                </div>
            </div>
            <Divider class="mt-2 mb-2 " />
            <div class="flex flex-wrap justify-content-around second-row-buttons py-1">
                <div  v-if="shouldShowAcceptRejectButton" @click="accept" class="flex align-items-center justify-content-center bg-blue-100 border-round"
                style="width: 2.5rem; height: 2.5rem; cursor: pointer;">
                    <i :class="['pi', 'pi-thumbs-up', 'text-blue-500']" />
                </div>
                <div  v-if="shouldShowAcceptRejectButton" @click="reject" class="flex align-items-center justify-content-center bg-blue-100 border-round"
                style="width: 2.5rem; height: 2.5rem; cursor: pointer;">
                    <i :class="['pi', 'pi-thumbs-down', 'text-blue-500']" />
                </div>
                <div v-if="shouldShowConfirmDealButton" @click="confirmOp" class="flex align-items-center justify-content-center bg-blue-100 border-round"
                style="width: 2.5rem; height: 2.5rem; cursor: pointer;">
                    <i :class="['pi', 'pi-thumbs-up', 'text-blue-500']" />
                </div>
                <div  v-if="shouldShowCancelButton" @click="cancel" class="flex align-items-center justify-content-center bg-blue-100 border-round"
                style="width: 2.5rem; height: 2.5rem; cursor: pointer;">
                    <i :class="['pi', 'pi-trash', 'text-blue-500']" />
                </div>
                <div  v-if="shouldShowConfirmRetrievalButton" @click="confirmRetrieval" class="flex align-items-center justify-content-center bg-blue-100 border-round"
                style="width: 2.5rem; height: 2.5rem; cursor: pointer;">
                    <i :class="['pi', 'pi-thumbs-up', 'text-blue-500']" />
                </div>
                <div  v-if="shouldShowEvaluateUserButton" @click="evaluateUser" class="flex align-items-center justify-content-center bg-blue-100 border-round"
                style="width: 2.5rem; height: 2.5rem; cursor: pointer;">
                    <i :class="['pi', 'pi-star', 'text-blue-500']" />
                </div>
                <div  v-if="authStore.amIAdmin()" @click="showFlow" class="flex align-items-center justify-content-center bg-blue-100 border-round"
                style="width: 2.5rem; height: 2.5rem; cursor: pointer;">
                    <i :class="['pi', 'pi-search', 'text-blue-500']" />
                </div>
                <div @click="handleFlagButton" class="flex align-items-center justify-content-center bg-blue-100 border-round"
                style="width: 2.5rem; height: 2.5rem; cursor: pointer;">
                    <i :class="['pi', 'pi-flag', 'text-blue-500']" :flip="shouldFlagFlip" />
                </div>
            </div>
        </template>
    </Card>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useDialog } from 'primevue/usedialog'
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '@/stores/auth'
import { useConfirm } from "primevue/useconfirm"
import { operationTypeEnum } from '@/helpers/Constants'
import { operationStatusEnum, operationStatusNumericEnum, genericServerMessageEnum } from '@/helpers/Constants'
import UserOverview from '@/components/UserOverview.vue'
import BookOverview from '@/components/BookOverview.vue'
import ChatThread from '@/components/ChatThread.vue'
import FlowOverview from '@/components/FlowOverview.vue'
import OperationOverview from '@/components/OperationOverview.vue'
import userService from '@/service/UserService'
import operationService from '@/service/OperationService'
import FlagOperationDialog from './FlagOperationDialog.vue'
import Card from 'primevue/card';
import Divider from 'primevue/divider';

const props = defineProps({
    operation: {
        type: Object,
        required: true
    }
})

const booksPreview = ref([])

const i18n = useI18n()
const dialog = useDialog()
const confirm = useConfirm()

const emit = defineEmits(['operation-status-changed', 'operation-error-occurred', 'sender-evaluated', 'receiver-evaluated',
    'messages-read-mark', 'incidence-registered'])

const authStore = useAuthStore()

onMounted(() => {
    let top = 0
    let left = 0
    let allBooks = [...props.operation.myBooks]
    allBooks = allBooks.concat(props.operation.otherBooks)
    const imgs = allBooks.filter(b => b.imageUrl !== undefined && b.imageUrl !== null).slice(0, 3).map(b => b.imageUrl)
    if (imgs.length === 0) {
        imgs.push(require('@/assets/blank_book_cover.jpg'))
    }
    if (imgs.length === 1) {
        top = 0.5
        left = 0.5
    }
    for (const img of imgs) {
        const imgObj = {
            'src': img,
            'style': `position: absolute;top: ${top += 0.5}em;left: ${left += 0.5}em;`
        }
        booksPreview.value.push(imgObj)
    }
})


const shouldReadChat = computed(() => {
    return props.operation.unreadMessages === true
})

const shouldFlagFlip = computed(() => {
    return authStore.amIAdmin() && (!!props.operation.senderIncidence || !!props.operation.receiverIncidence)
})

const shouldShowAcceptRejectButton = computed(() => {
    const adminApproval = authStore.amIAdmin() && props.operation.statusId === operationStatusEnum.CREATED
    const receiverApproval = !authStore.amIAdmin() && props.operation.receiver.id === authStore.user.id && props.operation.statusId === operationStatusEnum.APPROVED_BY_ADMIN
    return adminApproval || receiverApproval
})

const shouldShowCancelButton = computed(() => {
    const senderSituation = operationStatusEnum.WAITING_DEAL_CONFIRMATION === props.operation.statusId && props.operation.sender.id === authStore.user.id
    const receiverSituation = operationStatusEnum.WAITING_DEAL_CONFIRMATION === props.operation.statusId && props.operation.receiver.id === authStore.user.id
    return senderSituation || receiverSituation
})

const shouldShowConfirmDealButton = computed(() => {
    const senderSituation = [operationStatusEnum.WAITING_DEAL_CONFIRMATION, operationStatusEnum.DEAL_CONFIRMED_BY_RECEIVER].includes(props.operation.statusId) && props.operation.sender.id === authStore.user.id
    const receiverSituation = [operationStatusEnum.WAITING_DEAL_CONFIRMATION, operationStatusEnum.DEAL_CONFIRMED_BY_SENDER].includes(props.operation.statusId) && props.operation.receiver.id === authStore.user.id
    return senderSituation || receiverSituation
})

const shouldShowConfirmRetrievalButton = computed(() => {
    const senderSituation = [operationStatusEnum.IN_PROGRESS, operationStatusEnum.RETRIEVED_BY_RECEIVER].includes(props.operation.statusId) && props.operation.sender.id === authStore.user.id
    const receiverSituation = [operationStatusEnum.IN_PROGRESS, operationStatusEnum.RETRIEVED_BY_SENDER].includes(props.operation.statusId) && props.operation.receiver.id === authStore.user.id
    return senderSituation || receiverSituation
})

const shouldShowEvaluateUserButton = computed(() => {
    const conditionA = props.operation.statusId === operationStatusEnum.COMPLETED
    const conditionB = (props.operation.sender.id === authStore.user.id && props.operation.receiverEvaluated === false)
        || (props.operation.receiver.id === authStore.user.id && props.operation.senderEvaluated === false)
    return conditionA && conditionB
})

const showUserInfo = (userId) => {
    dialog.open(UserOverview, {
        props: {
            header: i18n.t('USER_INFO'),
            style: {
                width: '20em',
            },
            breakpoints: {
                '960px': '75vw',
                '640px': '90vw'
            },
            modal: true
        },
        data: {
            userId: userId,
        }
    })
}

const showOperationInfo = () => {
    dialog.open(OperationOverview, {
        props: {
            header: i18n.t('OPERATION_INFO'),
            style: {
                width: '20em',
                
            },
            breakpoints: {
                '960px': '75vw',
                '640px': '90vw'
            },
            modal: true,
            contentStyle: {
                textAlign: 'center',

            },
        },
        data: {
            operation: props.operation,
        }
    })
}

const showBooksList = () => {
    dialog.open(BookOverview, {
        props: {
            header: i18n.t('BOOKS_LIST'),
            style: {
                width: '20em',
            },
            breakpoints: {
                '960px': '75vw',
                '640px': '90vw'
            },
            modal: true
        },
        data: {
            myBooks: props.operation.myBooks,
            otherBooks: props.operation.otherBooks,
            operationType: props.operation.typeId
        }
    })
}

const showChat = async () => {
    dialog.open(ChatThread, {
        emits: {
            onError: (e) => {
                emit('operation-error-occurred', e)
            }
        },
        props: {
            header: i18n.t('CHAT'),
            style: {
                width: '50vw'
            },
            breakpoints: {
                '960px': '75vw',
                '640px': '90vw'
            },
            modal: true
        },
        data: {
            operation: props.operation
        },
        onClose: async (e) => {
            const issuedByUser = e.data === undefined || e.data.causedByLogout === false
            if (issuedByUser && !authStore.amIAdmin()) {
                const markResponse = await operationService.markMessagesRead(props.operation.id)
                if (markResponse.message === genericServerMessageEnum.OK) {
                    emit('messages-read-mark', props.operation.id)
                }
            }
        }
    })
}

const accept = () => {
    confirm.require({
        message: i18n.t('ACCEPT_OPERATION'),
        acceptLabel: i18n.t('YES'),
        rejectLabel: i18n.t('NO'),
        accept: async () => {
            const response = await operationService.approve(props.operation.id, true)
            const newStatus = response.result.value
            emit('operation-status-changed', props.operation.id, newStatus, i18n.t('ACCEPT_CONFIRMED'))
        }
    })
}

const reject = () => {
    confirm.require({
        message: i18n.t('REJECT_OPERATION'),
        acceptLabel: i18n.t('YES'),
        rejectLabel: i18n.t('NO'),
        accept: async () => {
            try {
                const response = await operationService.approve(props.operation.id, false)
                const newStatus = response.result.value
                emit('operation-status-changed', props.operation.id, newStatus, i18n.t('REJECT_CONFIRMED'))
            } catch (error) {
                emit('operation-error-occurred', error)
            }
        }
    })
}

const cancel = () => {
    confirm.require({
        message: i18n.t('CANCEL_OPERATION'),
        acceptLabel: i18n.t('YES'),
        rejectLabel: i18n.t('NO'),
        accept: async () => {
            try {
                const response = await operationService.cancel(props.operation.id)
                const newStatus = response.result.value
                emit('operation-status-changed', props.operation.id, newStatus, i18n.t('CANCEL_CONFIRMED'))
            } catch (error) {
                emit('operation-error-occurred', error)
            }
        }
    })
}

const confirmOp = () => {
    confirm.require({
        message: i18n.t('CONFIRM_OPERATION'),
        acceptLabel: i18n.t('YES'),
        rejectLabel: i18n.t('NO'),
        accept: async () => {
            try {
                const response = await operationService.confirm(props.operation.id)
                const newStatus = response.result.value
                emit('operation-status-changed', props.operation.id, newStatus, i18n.t('CONFIRMATION_DONE'))
            } catch (error) {
                emit('operation-error-occurred', error)
            }
        }
    })
}

const confirmRetrieval = () => {
    confirm.require({
        message: i18n.t('CONFIRM_RETRIEVAL'),
        acceptLabel: i18n.t('YES'),
        rejectLabel: i18n.t('NO'),
        accept: async () => {
            try {
                const response = await operationService.confirmRetrieval(props.operation.id)
                const newStatus = response.result.value
                emit('operation-status-changed', props.operation.id, newStatus, i18n.t('RETRIEVAL_CONFIRMED'))
            } catch (error) {
                emit('operation-error-occurred', error)
            }
        }
    })
}

const evaluateUser = () => {
    confirm.require({
        message: i18n.t('CONFIRM_USER_EVALUATION'),
        acceptLabel: i18n.t('YES'),
        rejectLabel: i18n.t('NO'),
        accept: async () => {
            try {
                if (props.operation.sender.id === authStore.user.id) {
                    await userService.evaluateUser(props.operation.receiver.id, props.operation.id)
                    emit('receiver-evaluated', props.operation.id)
                } else {
                    await userService.evaluateUser(props.operation.sender.id, props.operation.id)
                    emit('sender-evaluated', props.operation.id)
                }
            } catch (error) {
                emit('operation-error-occurred', error)
            }
        }
    })
}

const showFlow = () => {
    dialog.open(FlowOverview, {
        props: {
            style: {
                width: '25em',
            },
            breakpoints: {
                '960px': '75vw',
                '640px': '90vw'
            },
            modal: true
        },
        data: {
            operationId: props.operation.id
        },
        emits: {
            onFlowQueryFailed: (e) => {
                emit('operation-error-occurred', e)
            }
        }
    })
}

const getOperationTypeIcon = (typeId) => {
    if (typeId === operationTypeEnum.GIFT) {
        return "pi-gift"
    } else if (typeId === operationTypeEnum.BORROWING) {
        return "pi-file-import"
    }
    return "pi-sync"
}

const handleFlagButton = () => {
    dialog.open(FlagOperationDialog, {
        props: {
            style: {
                width: '25em',
            },
            breakpoints: {
                '960px': '75vw',
                '640px': '90vw'
            },
            modal: true
        },
        data: {
            operation: props.operation
        },
        emits: {
            onIncidenceRegisterFailed: (e) => {
                emit('operation-error-occurred', e)
            },
            onIncidenceRegistered: (e) => {
                emit('incidence-registered', e)
            }
        }
    })

}

</script>

<style scoped>
.card {
  min-width: 175px;
  background: var(--surface-section);
  padding: 0.5rem !important;
  margin-bottom: 2rem;
  box-shadow: var(--card-shadow);
  border-radius: 12px;

  &:last-child {
    margin-bottom: 0;
  }
}

@media (max-width: 344px) {
    .card {
  min-width: 160px;
} 
}

.divider-color{
    border-top: 1px solid #435a8540 !important;
}

.header-info {
    width: 100%;
    height: 50px;
}

.timestamp{
    background-color: #435a85;
    color: #e5e3d7;
}

.operation_card {
    background: #e5e3d7 !important;
    border-radius: 18px !important;
    border: 0.1px solid #e5e3d7 !important;
    margin: 5px;
    text-align: center;
}

.operation_card:deep(.p-card-title) {
    margin-bottom: 0px !important;
}

.operation_card:deep(.p-card-content) {
    padding: 0px !important;
}

.user_avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    cursor: pointer;
}

.books_preview {
    position: absolute;
    height:7.5em;
    width: 5.5em;
    margin-left: 15%;
    margin-bottom: 1rem;
    cursor: pointer;
}

.user_overview .p-dialog-title {
    margin: auto;
}

.daysToExpire {
    display: flex;
    justify-content: center;
    align-items: center;
    direction: initial;
    background-color: var(--blue-600);
    color: rgb(255 255 255);
    width: 35px;
    height: 35px;
    border-radius: 50%;
    cursor: pointer;
}

.operation_card :deep(.p-card-body) {
    padding: 5px;
}

.first-row-buttons {
    height: 40px;
    align-items: center;
}

.first-row-buttons>* {
    margin: 0 6px 0 6px;
}

.second-row-buttons>button {
    direction: initial;
    padding: 0px !important;
}

.p-divider.p-divider-horizontal:before {
    border-top: 1px solid var(--blue-100);
    opacity: 1;
  }

  .info_dialog:deep(.p-dialog-content) {
    text-align: center;
    line-height: 2.5rem;
}

</style>